import { createFileRoute } from '@tanstack/react-router'
import { HouseholdMembersPage } from '_/features/finance/ui/pages/household-members-page'

export const Route = createFileRoute('/_authenticated/finance/household')({
	staticData: { title: 'finance_household_title' },
	component: HouseholdMembersPage,
})
